// Dependencies
import React from 'react';
import radium from 'radium';
import { ThemeContext } from '../../components/theme/Theme.jsx';
import {API_URL} from "../../dev";

function Image(props) {
	const context = React.useContext(ThemeContext);
	const style = {
		container: {
			float: 'left',
			margin: context.themeManager.value('event-image', 'margin'),
			flexShrink: '0',
			paddingBottom: '1.5em',
			width: '100%',
			'@media (min-width : 768px)': {
				width: '40%',
				paddingBottom: '0',
			},
		},
		figure: {
			width: '100%',
			padding: '0 0 0.5em 0',
			'@media (min-width : 768px)': {
				padding: '0 1.5em 0.2em 0',
			},
		},
		image: {
			width: '100%',
		},
		caption: {
			fontSize: '0.9em',
			wordBreak: 'break-all',
		},
		source: {
			fontSize: '0.8em',
			fontWeight: 300,
			wordBreak: 'break-all',
		},
	};
	return props.imageMetaData.id ?
		(
			<div className="event__image-container" style={style.container}>
				<figure style={style.figure}>
					<img
						src={`${API_URL}/v1/files/scaled/IMG600/${props.imageMetaData.id}`}
						alt={props.imageMetaData.altText}
						className="event__image"
						style={style.image}
					/>
					<figcaption style={style.caption}>{props.imageMetaData.caption}</figcaption>
					<figcaption style={style.source}>{`Quelle: ${props.imageMetaData.source}`}</figcaption>
				</figure>
			</div>
		) : (null);
}

export default radium(Image);
